<template>
  <div>
    <tool-bar :title="title" subTitle=""></tool-bar>
    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"></activity-redirect-item>

    <div v-if="perfiosLink" class="margin_top_40 margin-left-20 margin-right-20">
      <weex-text class="font-size-base">
        <span>{{secureBankingHeading}}</span>
        <a :href="perfiosLink" target="_top">Click here</a>
        <span> to continue.</span>
      </weex-text>
    </div>
  </div>
</template>
<script>
import ToolBar from "../../layout/ToolBar";
import LoanScopeDataHolder from "@/data/model/LoanScopeDataHolder";
import dataSource from "@/data/DataSource";
import Loading from "@/components/layout/Loading";
import { Activities } from "@/utils/ActivityNavigator";
import ActivityRedirectItem from "../../layout/ActivityRedirectItem";
import ErrorAlertItem from "@/components/layout/ErrorAlertItem";

export default {
  name: "PerfiosActivity",
  components: { ToolBar, Loading, ActivityRedirectItem, ErrorAlertItem },
  data: () => ({
    title: "Perfios",
    perfiosLink: "",
    loading: false,
    networkError: {},
    errorAlertEvent: false
  }),

  methods: {
    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    }
  },

  created: function () {
    this.loading = true;
    dataSource.initiatePerfios({
      loanId: LoanScopeDataHolder.getLoanId(),
      clientId: LoanScopeDataHolder.getClientId(),
      type: LoanScopeDataHolder.getPerfiosTransactionType(),
      loanDuration: 1
    }).then(res => {
      this.loading = false;
      if (res.errorOccurred) {
        this.showError(res.data)
      } else {
        LoanScopeDataHolder.setPerfiosPayload(res.data)
        this.perfiosLink = res.data.url;
      }
    })
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.BANK_STATEMENT]
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name : "";
    },

    secureBankingHeading() {
      return "You are going to be redirected to a secure banking environment. "
    }
  }
}

</script>

<style scoped src="../../../assets/style/base.css"></style>

